import { IQuoteSection } from 'types/quote'

const Sixth = ({ quoteInfo }: IQuoteSection) => {
    return (
        <div className='bg-white border-[#9D9EB7] border-1 rounded-lg'>
            <div className='bg-[#F8F8FA] px-10 py-6 rounded-t-lg'>
                <p className='font-semibold first-line:text-2xl'>요청사항</p>
            </div>

            <div className='px-10 py-6'>
                <div className='flex items-start'>
                    <p className='w-[170px] text-lg shrink-0'>요청사항</p>
                    <div className='flex flex-col flex-[1] gap-6 rounded-lg max-w-[724px]'>
                        <textarea
                            className={`w-[600px] h-full rounded-lg p-6 text-sm bg-[#F8F8FA] resize-none`}
                            rows={6}
                            disabled
                            value={quoteInfo.step3?.description || ''}
                        >
                        </textarea>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Sixth